module.exports = __webpack_public_path__ + "static/media/favicon.a031bdae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/favicon.svg
// module id = 876
// module chunks = 0